import { AMUSEMENT_TICKET_DETAIL_TABS } from 'modules/Amusement/AmusementTicketDetailPage/constants';
import { PEAK_SEASON_CONFIG_TYPE } from 'modules/Configuration/PeakSeasonConfigPage/constants';
import {
  HOTEL_DETAIL_TABS,
  HOTEL_ROOM_DETAIL_TABS,
} from 'modules/Hotel/HotelDetailPage/constants';
import { createElement, ReactNode } from 'react';
import { lazyImport } from 'routes/helpers';
import { getPath } from 'routes/router-paths';
import { REGION, MODULE_TYPE } from 'utils/constants';

export type TBreadcrumb = {
  title: string;
  path?: string;
};

export type TRoute = {
  path: string;
  element: ReactNode;
  permissionKeys?: string[];
  pageHeader?: string;
  breadcrumbs?: TBreadcrumb[];
};

export type TPageInfo = {
  pageTitle: string;
};

export const publicRoutes: TRoute[] = [
  {
    path: getPath('loginPage'),
    element: createElement(
      lazyImport(() => import('modules/Authentication/LoginPage')),
      { pageTitle: 'Đăng nhập' }
    ),
  },
];

export const privateRoutes: TRoute[] = [
  {
    path: getPath('dashboardPage'),
    element: createElement(
      lazyImport(() => import('modules/Miscellaneous/DashboardPage')),
      { pageTitle: 'Dashboard' }
    ),
  },

  /** Configuration module */
  {
    path: getPath(
      'peakSeasonConfigPage',
      ':moduleType' as MODULE_TYPE,
      ':configType' as PEAK_SEASON_CONFIG_TYPE
    ),
    element: createElement(
      lazyImport(() => import('modules/Configuration/PeakSeasonConfigPage'))
    ),
  },

  /** Hotel module */
  {
    path: getPath('hotelListPage'),
    element: createElement(
      lazyImport(() => import('modules/Hotel/HotelListPage'))
    ),
  },
  {
    path: getPath(
      'hotelDetailPage',
      ':hotelId',
      ':sectionId' as HOTEL_DETAIL_TABS
    ),
    element: createElement(
      lazyImport(() => import('modules/Hotel/HotelDetailPage'))
    ),
  },
  {
    path: getPath(
      'hotelRoomDetailPage',
      ':hotelId',
      ':roomId',
      ':sectionId' as HOTEL_ROOM_DETAIL_TABS
    ),
    element: createElement(
      lazyImport(
        () => import('modules/Hotel/HotelDetailPage/HotelRoomDetailPage')
      )
    ),
  },
  {
    path: getPath('hotelBookingReportPage'),
    element: createElement(
      lazyImport(() => import('modules/Hotel/HotelBookingReportPage'))
    ),
  },

  /** Tour module */
  {
    path: getPath('tourRouteManagementPage', ':region' as REGION),
    element: createElement(
      lazyImport(() => import('modules/Tour/TourRouteManagementPage'))
    ),
  },
  {
    path: getPath('tourListPage', ':region' as REGION),
    element: createElement(
      lazyImport(() => import('modules/Tour/TourListPage'))
    ),
  },
  {
    path: getPath('tourDetailPage', ':tourId'),
    element: createElement(
      lazyImport(() => import('modules/Tour/TourDetailPage'))
    ),
  },
  {
    path: getPath('tourBookingListPage'),
    element: createElement(
      lazyImport(() => import('modules/Tour/TourBookingListPage'))
    ),
  },

  /** Amusement tickets module */
  {
    path: getPath('amusementListPage'),
    element: createElement(
      lazyImport(() => import('modules/Amusement/AmusementTicketsListPage'))
    ),
  },
  {
    path: getPath(
      'amusementTicketDetailPage',
      ':amusementTicketId',
      ':section' as AMUSEMENT_TICKET_DETAIL_TABS
    ),
    element: createElement(
      lazyImport(() => import('modules/Amusement/AmusementTicketDetailPage'))
    ),
  },
];
